export const scrollToHash = (anchorId, offset = 0, container = window) => {
  let target = document.querySelector(anchorId);
  if (!target) return;

  const bodyRect = document.body.getBoundingClientRect().top;
  const elementRect = target.getBoundingClientRect().top;

  const elementPosition = elementRect - bodyRect;
  const offsetPosition = elementPosition - offset;

  container.scrollTo({ top: offsetPosition, behavior: 'smooth' });
};

export const scrollToHashInDiv = (anchorId, container, offset = 0) => {
  let target = document.querySelector(anchorId);
  if (!target) return;

  const elementPosition = target.offsetTop;
  const offsetPosition = elementPosition - offset;

  container.scrollTo({ top: offsetPosition, behavior: 'smooth' });
};

export const scrollToTop = () => {
  window.scrollTo({ top: 0, behavior: 'smooth' });
};